/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import { cx } from '@emotion/css'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'

import CloseCircleOutlineIcon from '@offerzen/zenicon/CloseCircleOutlineIcon'
import { colors } from '../../themes'
import AccessibleIcon from '../AccessibleIcon'

import styles, { bodySize } from './styles'

class PopupTip extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    open: false,
    offsetLeft: 0,
    width: 0,
  }

  constructor(props) {
    super(props)

    this.triggerRef = React.createRef()
  }

  componentDidMount() {
    window.addEventListener('resize', debounce(this.resize, 10))

    this.setState({
      offsetLeft: this.getTriggerLeftWindowOffset(),
      width: this.getDocumentWidth(),
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize)
  }

  resize = () => {
    this.setState({ offsetLeft: this.getTriggerLeftWindowOffset() })
  }

  getTriggerLeftWindowOffset = () => {
    if (!this.triggerRef.current) return null

    return this.triggerRef.current.getBoundingClientRect().left
  }

  // eslint-disable-next-line class-methods-use-this
  getDocumentWidth = () => document.documentElement.clientWidth

  togglePopupTip = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const nextOpenState = !this.state.open

    let { offsetLeft } = this.state
    let { width } = this.state
    if (nextOpenState) {
      offsetLeft = this.getTriggerLeftWindowOffset()
      width = this.getDocumentWidth()
    }

    this.setState({
      open: nextOpenState,
      offsetLeft,
      width,
    })

    if (this.state.open && this.props.onOpen) this.props.onOpen()
  }

  render() {
    const { children, trigger: Trigger, className, triggerClassName, ...triggerProps } = this.props
    triggerProps.className = triggerClassName

    return (
      <div className={cx(styles.wrapper, className)} ref={this.triggerRef} onClick={this.togglePopupTip}>
        <Trigger
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...triggerProps}
        />
        {Boolean(this.state.open) && (
          <>
            <div onClick={this.togglePopupTip} className={styles.overlay} />
            <div className={cx(styles.body, bodySize(this.state.offsetLeft, this.state.width))}>
              <button type="button" onClick={this.togglePopupTip} className={styles.closeButton} aria-label="Close">
                <AccessibleIcon icon={CloseCircleOutlineIcon} color={colors.white} size={24} />
              </button>
              <div className={styles.children}>{children}</div>
            </div>
          </>
        )}
      </div>
    )
  }
}
PopupTip.propTypes = {
  trigger: PropTypes.func,
  className: PropTypes.string,
  triggerClassName: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onOpen: PropTypes.func,
}

export default PopupTip
